module.exports = __webpack_public_path__ + "static/ciok-c23c7f8a1689d74e3a6046c63dee3449.jpg";